import { Warning } from '@carbon/icons-react'
import { cx } from 'lib/cx'
import styles from './styles.module.css'

export default function EditorError() {
  return (
    <div className={styles.editor}>
      <div className="border-support-error/50 my-4 rounded-md border-2 border-dashed px-4 py-2">
        <div className={cx(styles.editable, 'flex items-center gap-2')}>
          <Warning className="h-5 w-5" />
          <b className="font-medium">Fehler beim Anzeigen des Textes</b>
        </div>
      </div>
    </div>
  )
}
